var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn-xs add_book",attrs:{"type":"button","data-toggle":"modal","data-target":'#' + _vm.addressBookId}},[_c('i',{staticClass:"fa fa-user "})])])}
var staticRenderFns = []

export { render, staticRenderFns }